import { render, staticRenderFns } from "./AboutBeesSingle.vue?vue&type=template&id=ffc32658"
import script from "./AboutBeesSingle.vue?vue&type=script&lang=js"
export * from "./AboutBeesSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports